import { addClassNamesToElement } from "@lexical/utils"
import { $applyNodeReplacement, ElementNode } from "lexical"
import { PIXEL_VALUE_REG_EXP } from "./constants"

/** @noInheritDoc */
export class TableRowNode extends ElementNode {
  /** @internal */
  __height

  static getType() {
    return "tablerow"
  }

  static clone(node) {
    return new TableRowNode(node.__height, node.__key)
  }

  static importDOM() {
    return {
      tr: (node) => ({
        conversion: $convertTableRowElement,
        priority: 0,
      }),
    }
  }

  static importJSON(serializedNode) {
    return $createTableRowNode(serializedNode.height)
  }

  constructor(height, key) {
    super(key)
    this.__height = height
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      ...(this.getHeight() && { height: this.getHeight() }),
      type: "tablerow",
      version: 1,
    }
  }

  createDOM(config) {
    const element = document.createElement("tr")

    if (this.__height) {
      element.style.height = `${this.__height}px`
    }

    addClassNamesToElement(element, config.theme.tableRow)

    return element
  }

  isShadowRoot() {
    return true
  }

  setHeight(height) {
    const self = this.getWritable()
    self.__height = height
    return this.__height
  }

  getHeight() {
    return this.getLatest().__height
  }

  updateDOM(prevNode) {
    return prevNode.__height !== this.__height
  }

  canBeEmpty() {
    return false
  }

  canIndent() {
    return false
  }
}

export function $convertTableRowElement(domNode) {
  const domNode_ = domNode
  let height = undefined

  if (PIXEL_VALUE_REG_EXP.test(domNode_.style.height)) {
    height = parseFloat(domNode_.style.height)
  }

  return { node: $createTableRowNode(height) }
}

export function $createTableRowNode(height) {
  return $applyNodeReplacement(new TableRowNode(height))
}

export function $isTableRowNode(node) {
  return node instanceof TableRowNode
}
